import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { IngresoService } from '../../servicios/ingreso.service';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { Router } from '@angular/router';
import { timer } from 'rxjs';

@Component({
  selector: 'app-slider-becario',
  templateUrl: './slider-becario.component.html',
  styleUrls: ['./slider-becario.component.css']
})
export class SliderBecarioComponent implements OnInit {

  public vecBecas = []; public vecTipoBeca = [];

  constructor(private cargando: LoaderComponent, private srvSelect: SeleccionService, private tools: ToolsService,
    private modalService: NgbModal, private srvInsert: IngresoService, private alerti: AlertifyService, private ruta: Router) { }

  ngOnInit() {
    this.verBecas();
  }
  //FUNCION QUE PERMITE VER TODAS LAS BECAS REGISTRADAS
  async verBecas() {
    this.vecBecas = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionBecas(6, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      for (let i in res.becas) {
        this.vecBecas.push({
          idBeca: res.becas[i]['intIdBecas'], nombre: res.becas[i]['strNombre'], descripcion: res.becas[i]['strDescripcion']
        });
      }
    }
  }
  //NAVEGACION ENTRE PAGINAS
  irPagina(objBeca, ruta) {
    this.ruta.navigate(["/becario"]);

    const source = timer(500, 500);
    const subscribe = source.subscribe(val =>
      this.navegarBecario(objBeca['idBeca'], objBeca['nombre'], ruta)
    );
  }
  //FUNCION QUE PERMITE NAVEGAR AL BECARIO DE BECAS ENTRE LAS RUTAS QUE SELECCIONA
  navegarBecario(beca, nombBeca, direccion) {
    localStorage.setItem('tipoBeca', beca);
    localStorage.setItem('nombBeca', nombBeca);
    this.ruta.navigate(["/becario/" + direccion]);
  }
  verPostula() {
    this.ruta.navigate(["/becario/verPostula"]);
  }
}
